import { EventType } from '@typings/api/novel/origin_overseas_base';

export const EventMap = {
    [EventType.DetailPageComment]: 0,
    [EventType.Post]: 1,
};
